import { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";

import { Authorization, useAuthorization } from "../../common/AuthorizationCpt";
import IconArrowRight from "../../images/icon_arrow_right.svg";
import { ImportFlowScreens } from "../../utils/constants";
import { USER_ROUTES } from "../../utils/routeConstants";
import BillingScreen from "../BillingScreen/BillingScreen";
import Payment from "../Payment/Payment";
import {
  StepContent,
  StepDescription,
  StepNumber,
  StepsBar,
} from "../Steps/StepsStyles";
import VctScreen from "../VctScreen/VctScreen";
import { Header, MainContainer } from "./BillingStyles";

const STEPS = {
  pedidos: {
    description: "Pedidos",
    screenName: ImportFlowScreens.ORDERS,
    path: USER_ROUTES.ORDERS.path,
    code: "quotation",
    authorization: ["dam.get_dam_estimate_intranet"],
  },
  pagos: {
    description: "Pagos",
    screenName: ImportFlowScreens.PAYMENT,
    path: USER_ROUTES.PAYMENT.path,
    code: "payment",
    authorization: [
      "quotation.get_quotation_quoted",
      "quotation.get_quotation_paid_intranet",
      "quotation.get_quotation_pending",
    ],
  },
  citas: {
    description: "Citas",
    screenName: ImportFlowScreens.VCT,
    path: USER_ROUTES.DATES.path,
    code: "dates",
    authorization: [
      "volante.get_volante_appointment",
      "appointment.get_appointments",
    ],
  },
};

function Billing(props) {
  const { userInfo } = props;
  const history = useHistory();

  const authorization = useAuthorization();

  const [steps] = useState(() => {
    const steps = Object.keys(STEPS)
      .map((key) => STEPS[key])
      .filter((step) => {
        return authorization.isAllowedByActions(step.authorization);
      });

    return steps;
  });

  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const unsub = history.listen((location) => {
      const index = steps.findIndex((step) =>
        location.pathname.startsWith(step.path)
      );
      setCurrentIndex(index);
    });

    const index = steps.findIndex((step) =>
      history.location.pathname.startsWith(step.path)
    );
    setCurrentIndex(index);

    return () => {
      unsub();
    };
  }, [steps, history]);

  return (
    <div>
      <Header>
        <StepsBar>
          <h1>{USER_ROUTES.BILLING_USERS_AGENT.title.toUpperCase()}</h1>
          <div className="step-tabs">
            {steps.map((step, index) => {
              return (
                <BillingStep
                  key={index}
                  onClick={() => {
                    history.push(step.path);
                  }}
                  index={index}
                  step={{ description: step.description }}
                  isCurrent={index === currentIndex}
                />
              );
            })}
          </div>
        </StepsBar>
      </Header>
      <MainContainer>
        <Authorization actions={STEPS.pedidos.authorization}>
          <Route path={USER_ROUTES.ORDERS.path}>
            <BillingScreen userInfo={userInfo} />
          </Route>
        </Authorization>
        <Authorization actions={STEPS.pagos.authorization}>
          <Route path={USER_ROUTES.PAYMENT.path}>
            <Payment />
          </Route>
        </Authorization>
        <Authorization actions={STEPS.citas.authorization}>
          <Route path={USER_ROUTES.DATES.path}>
            <VctScreen />
          </Route>
        </Authorization>
      </MainContainer>
    </div>
  );
}

export default Billing;

const BillingStep = (props) => {
  const { onClick, index, step, isCurrent } = props;
  const stepsInfo = [];
  return (
    <StepContent className="step-name">
      <StepNumber activated={isCurrent} onClick={onClick}>
        {index + 1}
      </StepNumber>
      <div onClick={onClick} onKeyDown={() => {}} role="button">
        <StepDescription isCurrent={isCurrent}>
          {step.description}
        </StepDescription>
      </div>
      <div className="arrowIcon">
        {index === stepsInfo.length - 1 ? null : (
          <img src={IconArrowRight} alt="arrowRight" />
        )}
      </div>
    </StepContent>
  );
};
